String.format = function (input, ...args) {
    return input.replace(/{(\d+)}/g, function (match, number) {
        return typeof args[number] != 'undefined' ? args[number] : match;
    });
};
String.isNullOrEmpty = function (val) {
    if (val && val != null && val.length > 0)
        return false;
    return true;
};
String.isNullOrWhitespace = function (val) {
    if (!String.isNullOrEmpty(val) && val != " ")
        return false;
    return true;
};
String.prototype.format = function (...args) {
    return String.format.call(this, this, args);
};
String.prototype.trunc = function (length, wordBoundary) {
    let isLong = this.length > length;
    let text = isLong ? this.substr(0, length - 1) : this;
    text = wordBoundary && isLong ? text.substr(0, text.lastIndexOf(' ')) : text;
    return isLong ? text + '&hellip;' : text;
};
String.prototype.isNullOrEmpty = function () {
    return String.isNullOrEmpty(this);
};
String.prototype.isNullOrWhitespace = function (val) {
    return String.isNullOrWhitespace(this);
};
String.prototype.parseJSONDate = function () {
    return new Date(parseInt(this.substr(6, 13), 10));
};
String.prototype.replaceAllTokens = function (token, newToken, ignoreCase) {
    let str = this + "";
    let i = -1;
    if (typeof token === "string") {
        if (ignoreCase) {
            while ((i = str.toLowerCase().indexOf(token, i >= 0 ? i + newToken.length : 0)) !== -1) {
                str = str.substring(0, i) +
                    newToken +
                    str.substring(i + token.length);
            }
        }
        else {
            return this.split(token).join(newToken);
        }
    }
    return str;
};
String.prototype.toClassName = function () {
    return this.replace(/[^a-z0-9]/g, function (s) {
        let c = s.charCodeAt(0);
        if (c == 32)
            return '-';
        if (c >= 65 && c <= 90)
            return '_' + s.toLowerCase();
        return '__' + ('000' + c.toString(16)).slice(-4);
    });
};
String.prototype.trimChar = function (char) {
    let regexp = new RegExp("^[" + char + "]+|[" + char + "]+$", "igm");
    return this.replace(regexp, "");
};
String.prototype.toHTML = function () {
    let support = false;
    try {
        let parser = new DOMParser();
        parser.parseFromString('x', 'text/html');
        support = true;
    }
    catch (err) {
        support = false;
    }
    if (support) {
        let parser = new DOMParser();
        let doc = parser.parseFromString(this, 'text/html');
        return doc.body.firstChild;
    }
    let dom = document.createElement('div');
    dom.innerHTML = this;
    return dom;
};
